<template>
  <div class="logout"></div>
</template>

<script>
export default {
  name: "Logout"
};
</script>

<style lang="scss" scoped>
</style>>



// WEBPACK FOOTER //
// src/components/Logout.vue